<script>
import { getCompressedUrl } from "@/utils/common"
import StaffAvatar from "@/components/StaffAvatar"
import { url_prefix } from "@/utils/uploadFile"
import { timeTypeList } from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import { quarters, halfYears } from "@/components/BaseComponents/static"
import dj from "dayjs"
import { getUser } from "@/utils/user"
import { getHalf } from "@/utils/sheet"

export default {
  name: "sub-table-item",
  components: { StaffAvatar },
  props: {
    value: [Object, Array, String, Number],
    stringValue: String,
    control: Object
  },
  data() {
    return { timeTypeList, quarters, halfYears }
  },
  render(h) {
    if (this.value === null || this.value === undefined || !this.control.display)
      return (
        <div class="sub-table-item">
          <span class="empty"> - - </span>
        </div>
      )
    let element = null
    switch (this.control._type) {
      case "time":
        var typeValue = this.getTypeValue(this.value)
        element = (
          <span v-tip class="text-color">
            {typeValue}
          </span>
        )
        break
      case "company":
      case "department":
        element = this.getCommonItem(this.value, this.control._type)
        break
      case "staff":
        element = this.getStaffItem(this.value)
        break
      case "ref":
        var refValue = this.getRefData(this.value, this.stringValue)
        element = <span v-tip>{refValue}</span>
        break
      case "option":
        element = this.getOptionItem(this.value)
        break
      case "location":
        element = <span v-tip>{`${this.value.poiName} ${this.value.address}`}</span>
        break
      case "file":
        element = <span v-tip>{this.value.map(file => file.name).join(",")}</span>
        break
      case "area":
        element = <span v-tip>{this.value.join(",")}</span>
        break
      case "sign":
        element = this.getSignItem(this.value)
        break
      case "rich":
        element = <div class="rich" domPropsInnerHTML={this.value}></div>
        break
      case "rate":
        element = (
          <el-rate value={this.value} disabled colors={["#FF7373", "#FF7373", "#FF7373"]}></el-rate>
        )
        break
      default:
        element = (
          <span v-tip class="text-color">
            {this.value}
          </span>
        )
    }
    return <div class="sub-table-item">{element}</div>
  },
  methods: {
    getStaffItem(staffs) {
      let staffEls = (staffs || [])
        .map(staffVal => {
          if (this._.isString(staffVal)) return getUser(staffVal)
          return staffVal
        })
        .map(staff => (
          <div slot="reference" class="staff-item">
            <staff-avatar size="small" user={staff}></staff-avatar>
            <span class="right">{staff.name}</span>
          </div>
        ))
      return <div class="staff-wrapper">{staffEls}</div>
    },
    getCommonItem(vals, type) {
      return vals.map((val, idx) => (
        <div key={idx} class="common-item">
          <svg-icon icon-class={"field_" + type}></svg-icon>
          <span class="content" v-tip>
            {val.name}
          </span>
        </div>
      ))
    },
    getOptionItem(vals) {
      let optionMap = this._.keyBy(this.control.options, "value")
      let labelMap = this._.mapValues(optionMap, "label")
      let colorMap = this._.mapValues(optionMap, "color")
      let optionEls = (vals || []).map(val => (
        <span class={colorMap[val] || "plain"}>{labelMap[val]}</span>
      ))
      return <div class="option-wrapper">{optionEls}</div>
    },
    getSignItem(attachment) {
      let path = getCompressedUrl(url_prefix + attachment.path)
      return <img src={path} alt="" style="border: solid 1px grey;" />
    },
    getTypeValue(value) {
      let result = ""
      switch (this.control.timeType) {
        case "半年度": {
          let halfYear = this.halfYears.find(halfYear => getHalf(value) === halfYear.value)
          result = value.slice(0, 4) + "年" + halfYear.label
          break
        }
        case "季度": {
          let quarter = this.quarters.find(quarter => dj(value).quarter() === quarter.value)
          result = value + "年" + quarter.label
          break
        }
        default:
          result = dj(value).format(
            this.timeTypeList.find(timeType => timeType.value === this.control.timeType).djFormat
          )
          break
      }
      return result
    },
    getRefData(value, stringValue) {
      let result = ""
      if (this.control.oneFlag) {
        result = (value || []).map(t => t.title).join(",")
      } else {
        if (this._.isArray(value) && value.length) {
          if (this._.isString(value[0])) {
            result = stringValue
          } else {
            let firstField = this.control.fields[0]
            result = value.map(item => item.data[firstField]).join(",")
          }
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-table-item {
  overflow: hidden;
  display: flex;
  align-items: center;
  line-height: 23px;
  .staff-wrapper {
    display: flex;
    .staff-item {
      display: flex;
      align-items: center;
      background-color: #eaecf0;
      padding: 2px 4px;
      border-radius: 15px;
      .el-avatar {
        width: 20px;
        height: 20px;
        line-height: 20px;
        font-size: 10px;
      }
      .right {
        margin-left: 5px;
        color: #303133;
        flex: 1;
        white-space: nowrap;
      }
    }
  }
  .option-wrapper {
    display: flex;
    span {
      padding: 0 6px;
      border-radius: 6px;
      color: white;
      margin-right: 5px;
      white-space: nowrap;
      &.plain {
        color: unset;
      }
    }
  }
  .common-item {
    margin-right: 2px;
    color: #303133;
    display: flex;
    align-items: center;
    background-color: #eaecf0;
    padding: 2px 4px;
    border-radius: 4px;
    .svg-icon {
      margin-right: 5px;
    }
  }
  .rich {
    ::v-deep {
      p {
        margin: 0;
      }
    }
  }
}
</style>
